import { styled } from '@mui/material/styles';

const ServicesListStyledContainer = styled('div', { name: 'ServicesListStyledContainer' })`
  display: grid;
  gap: 70px;
`;

export default ServicesListStyledContainer;
